import React from 'react'
import { Margin, Text, Row, Col } from 'shared/components'
import * as styles from './styles'

const AppDeliveryComponent = () => {
  const sybject = 'Request for testing'
  const bodyText =
    'Please type in your apple ID after this line:You will receive invitation link shortly.'
  const email = 'info@inwin.online'
  return (
    <div css={styles.wrapper}>
      <Margin bottom={3}>
        <Text size={32} bold>
          App Beta Testing
        </Text>
      </Margin>

      <Row css={styles.wrapperRow}>
        <Col xs={12} sm={6}>
          <a
            css={styles.iconWrapper}
            href={`mailto:${email}?subject=${sybject}&body=${bodyText}`}
          >
            <img
              css={styles.icon}
              src="./img/icon_appstore__ev0z770zyxoy_large_2x.png"
            />
          </a>
          <Margin tb={2} css={styles.wrapText}>
            <Text size={24} bold>
              IOS
            </Text>
          </Margin>
        </Col>

        <Col xs={12} sm={6}>
          <a
            css={styles.iconWrapper}
            href="https://storage.googleapis.com/inwin-artifacts/InWin-1.0.1-rc4-release.apk"
          >
            <img css={styles.icon} src="./img/Android_logo_(2014-2019).png" />
          </a>
          <Margin tb={2} css={styles.wrapText}>
            <Text size={24} bold>
              Android
            </Text>
          </Margin>
        </Col>
      </Row>
    </div>
  )
}

AppDeliveryComponent.propTypes = {}

export default AppDeliveryComponent
